import React from 'react';
import { CheckCircle2, BookOpen, Headphones } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatYouGet() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-376">
      <div className="max-w-3xl mx-auto" data-id="element-377">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-gold" data-id="element-378">
          Here's Exactly What You Get Today
        </h2>

        <div className="space-y-6" data-id="element-379">
          {/* Core Product */}
          <div className="bg-navy-light border border-blue-800 rounded-xl p-6 flex gap-4 items-start shadow-lg" data-id="element-380">
            <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={28} data-id="element-381" />
            <div data-id="element-382">
              <h3 className="text-xl font-bold mb-1" data-id="element-383">
                The Main Archive: Voices of Freedom{' '}
                <span className="text-gold ml-2 text-sm font-bold" data-id="element-384">
                  ($47.97 Value)
                </span>
              </h3>
              <p className="text-gray-300 mb-2" data-id="element-385">
                The definitive account of the journey from a suburban basement
                to the front lines of the culture war. A tribute-style narrated
                biography you can read on any device—or listen while you drive.
              </p>
              <div className="flex items-center gap-2 text-blue-300 text-sm mt-2" data-id="element-386">
                <Headphones size={14} data-id="element-387" />
                <span className="italic" data-id="element-388">
                  + FREE Audiobook version included as a gift (75 min narration)
                </span>
              </div>
            </div>
          </div>

          {/* Bonus 1 */}
          <div className="bg-navy-light border border-blue-800 rounded-xl p-6 flex gap-4 items-start shadow-lg relative overflow-hidden" data-id="element-389">
            <div className="absolute top-0 right-0 bg-patriot-red text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-390">
              FREE BONUS
            </div>
            <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={28} data-id="element-391" />
            <div data-id="element-392">
              <h3 className="text-xl font-bold mb-1" data-id="element-393">
                The Heritage Timeline: Remembering Charlie Kirk{' '}
                <span className="text-gold ml-2 text-sm font-bold" data-id="element-394">
                  ($23.98 Value)
                </span>
              </h3>
              <p className="text-gray-300 mb-2" data-id="element-395">
                A year-by-year timeline of the movement's most defining moments
                and the quotes that sparked a generation—organized so you can
                revisit the legacy anytime and share it with family.
              </p>
              <div className="flex items-center gap-4 text-blue-300 text-sm mt-2" data-id="element-396">
                <span className="flex items-center gap-1" data-id="element-397">
                  <BookOpen size={14} data-id="element-398" /> eBook
                </span>
                <span className="flex items-center gap-1" data-id="element-399">
                  <Headphones size={14} data-id="element-400" /> Audiobook
                </span>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-navy-light border border-blue-800 rounded-xl p-6 flex gap-4 items-start shadow-lg relative overflow-hidden" data-id="element-401">
            <div className="absolute top-0 right-0 bg-patriot-red text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-402">
              FREE BONUS
            </div>
            <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={28} data-id="element-403" />
            <div data-id="element-404">
              <h3 className="text-xl font-bold mb-1" data-id="element-405">
                The Patriot's Playbook: The Last Patriot{' '}
                <span className="text-gold ml-2 text-sm font-bold" data-id="element-406">
                  ($23.99 Value)
                </span>
              </h3>
              <p className="text-gray-300 mb-2" data-id="element-407">
                Charlie's personal principles for survival and impact in a
                cancel-culture world—turned into a practical roadmap for your
                family.
              </p>
              <div className="flex items-center gap-4 text-blue-300 text-sm mt-2" data-id="element-408">
                <span className="flex items-center gap-1" data-id="element-409">
                  <BookOpen size={14} data-id="element-410" /> eBook
                </span>
                <span className="flex items-center gap-1" data-id="element-411">
                  <Headphones size={14} data-id="element-412" /> Audiobook
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center" data-id="element-413">
          <p className="text-2xl font-bold mb-2" data-id="element-414">
            Total Value:{' '}
            <span className="line-through text-gray-400" data-id="element-415">$95.94</span>
          </p>
          <p className="text-3xl font-bold text-gold mb-8" data-id="element-416">
            Yours Today For Just $17
          </p>
          <div className="max-w-md mx-auto" data-id="element-417">
            <CTAButton data-id="element-418">YES — UNLOCK MY BUNDLE FOR $17 →</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}